import { render, staticRenderFns } from "./ActionUI.vue?vue&type=template&id=b9f4cd96&scoped=true&"
import script from "./ActionUI.vue?vue&type=script&lang=js&"
export * from "./ActionUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f4cd96",
  null
  
)

export default component.exports